import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '?id=:id',
    name: 'Jobdetail',
    component: () => import('@/views/Jobdetail.vue'),
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/karriere/stellenangebote/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
